/**
 * Created by h3 on 2017-08-29.
 */

import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IBetLineWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {IWinRatioConfig, WinRatioType} from "@nolimitcity/slot-game/bin/core/winpresentation/WinRatio";
import {Timeline, TimelineLite} from "gsap";
import {DungeonQuestSymbolUtil} from "../../utils/DungeonQuestSymbolUtil";
import {StateMatrix} from "../../utils/StateMatrix";
import {DungeonQuestHelper} from "../bigSymbols/DungeonQuestHelper";
import {DungeonQuest} from "../DungeonQuest";
import {DungeonQuestGameConfig} from "../DungeonQuestGameConfig";
import {DungeonQuestSound} from "../DungeonQuestSound";
import {DungeonQuestBaseReelSymbol} from "../symbols/DungeonQuestBaseReelSymbol";


export class DungeonQuestInitialWPController extends WinPresentationController {

    protected _winSymbols:DungeonQuestBaseReelSymbol[];
    protected _noWinSymbols:StateReelSymbol[];
    private _symbolStates:StateMatrix<number>;
    private _masterTimeLine:TimelineLite | null;
    private _winType:WinRatioType;
    private _isBigWin:boolean;

    constructor(indexes:[number, number]) {
        super(indexes, {name : "DungeonQuestInitialWPController", skippable : true});
        this._winSymbols = [];
        this._noWinSymbols = [];
    }

    protected parseFeatureGameData(data:ParsedGameData):void {
        this._isBigWin = false;
        this._winType = WinRatioType.TINY;
        if(this._gameData) {
            if(this._gameData.currentWinRatioConfig && this._gameData.currentWinRatioConfig.type) {
                this._winType = this._gameData.currentWinRatioConfig.type;
            }

            this._isBigWin = this._gameData.isBigWin;
        }

        // #99
        DungeonQuestGameConfig.instance.WIN_BELOW_STAKE = (SlotGame.api.gameClientConfiguration.belowStakeWinRestriction && (data.singleWin <= data.playedBetValue));
    }

    protected hasWin():boolean {
        return this._betWinsData != null && this._betWinsData.length > 0;
    }

    protected startWinPresentation():void {
        let tl:TimelineLite = new TimelineLite();
        const gameData = this._gameData!;
        this._symbolStates = DungeonQuestSymbolUtil.createSymbolStateMatrixFromBetWinsWithWeights(<IBetLineWinData[]>this._betWinsData!);

        if(gameData.scatterPositions) {
            for(let i:number = 0; i < gameData.scatterPositions.length; i++) {
                const symbolPos:number = gameData.scatterPositions[i];
                if(symbolPos >= 0) {
                    this._symbolStates.setStateAt(i, symbolPos, -1);
                    const symbol:StateReelSymbol = Reels.getSymbol(i, symbolPos)!;
                    symbol.alpha = 0.2;
                }
            }
        }

        this._winSymbols = DungeonQuestSymbolUtil.getSymbolsWithState(this._symbolStates, 1);
        this._winSymbols = this._winSymbols.concat(DungeonQuestSymbolUtil.getSymbolsWithState(this._symbolStates, 2));
        this._winSymbols = this._winSymbols.concat(DungeonQuestSymbolUtil.getSymbolsWithState(this._symbolStates, 3));
        this._noWinSymbols = DungeonQuestSymbolUtil.getSymbolsWithState(this._symbolStates, 0);

        let noWinSymbolsAnimation:Timeline[] = DungeonQuestSymbolUtil.getSymbolStateAnimations(this._noWinSymbols, DungeonQuestGameConfig.instance.SYMBOL_STATES.noWin, 0.5);

        const winState = this.getWinState(this._gameData!.currentWinRatioConfig!);
        let winAnimations:Timeline[][] = DungeonQuestSymbolUtil.getSymbolStateAnimationsPerReel(this._winSymbols, winState, 0);

        let symAnimOffset = 0.36;
        let reelOffset = 0;
        let reelHitSoundDelay:number = DungeonQuestHelper.getSymbolWindUpDuration(DungeonQuestHelper.getWinTypeIndex(this._winType));

        for(let i:number = 0; i < winAnimations.length; i++) {
            if(winAnimations[i]) {
                let symbolsInReel = new TimelineLite();
                symbolsInReel.add(winAnimations[i], 0, "start", 0.0);
                tl.add([
                    symbolsInReel,
                    DungeonQuest.soundPlayer.playWinReelHit(reelHitSoundDelay)
                ], reelOffset);
                reelOffset += 0.1;
            }
        }

        // #99
        if (!DungeonQuestGameConfig.instance.WIN_BELOW_STAKE) {
            tl.add(() => SlotGame.sound.playEffect(DungeonQuestSound.WIN_WINDUP), 0);
            tl.add(() => SlotGame.sound.stopEffect(DungeonQuestSound.WIN_WINDUP), reelHitSoundDelay);
            tl.add(() => DungeonQuest.soundPlayer.playNormalWinSound(this._gameData!.currentWinRatioConfig!), reelHitSoundDelay);
        }

        if(!this._isBigWin) {
            let duration: number;

            // #99
            if (!DungeonQuestGameConfig.instance.WIN_BELOW_STAKE) {
                duration = tl.totalDuration() - symAnimOffset;
            } else {
                duration = 0;
            }
            tl.add(DungeonQuest.winCountUpDisplay.getWinDisplay(0, this._gameData!.singleWin, duration, this._winType), 0);
        }

        tl.add(() => SlotGame.winFieldController.showWinField(this._gameData!.totalWin));

        tl.add(noWinSymbolsAnimation, 0);

        tl.add(() => this.finish());
        this._masterTimeLine = tl;
    }

    protected stopWinPresentation(isAborted:boolean):void {
        //Stuff that happens after complete dispatch
        if(this._masterTimeLine) {
            if(isAborted) {
                let isActive = this._masterTimeLine.isActive();
                if(isActive) {
                    this._masterTimeLine.seek(this._masterTimeLine.totalDuration(), true);
                    this._masterTimeLine.pause();
                    this._masterTimeLine.kill();
                }
            }
            this._masterTimeLine = null;
        }

        if(!this._isBigWin) {
            DungeonQuest.winCountUpDisplay.getEndAnimation(this._gameData!.singleWin, this._winType);
            SlotGame.winFieldController.showWinField(this._gameData!.totalWin);
        }
        SlotGame.sound.stopEffect(DungeonQuestSound.WIN_WINDUP);
        DungeonQuestSymbolUtil.removeFromArrayAndSetStateToNormal(this._winSymbols);

        /*        if (isAborted){
                    DungeonQuestSymbolUtil.removeFromArrayAndSetStateToNormal(this._noWinSymbols);
                }*/

        this._noWinSymbols = [];
    }

    private getWinState(winRatioConfig:IWinRatioConfig):ISymbolStateConfig {
        let state:ISymbolStateConfig;
        switch(winRatioConfig.type) {
            case WinRatioType.TINY:
                state = DungeonQuestGameConfig.instance.SYMBOL_STATES.win;
                break;
            case WinRatioType.SMALL:
                state = DungeonQuestGameConfig.instance.SYMBOL_STATES.win;
                break;
            case WinRatioType.MEDIUM:
                state = DungeonQuestGameConfig.instance.SYMBOL_STATES.win2;
                break;
            case WinRatioType.LARGE:
                state = DungeonQuestGameConfig.instance.SYMBOL_STATES.win3;
                break;
            default:
                state = DungeonQuestGameConfig.instance.SYMBOL_STATES.win;
                break;
        }
        return state;
    }
}